import { Stack, Typography } from "@mui/material";
import { ReuseTooltip } from "../ui";
import { Groups } from "../../types/enums";
import { ReactNode } from "react";
import { TwoPersonIcon } from "../images/TwoPersonIcon";

const mapper: Record<
  Groups,
  { tooltip: string; label: string; icon?: ReactNode }
> = {
  [Groups.committee]: {
    label: "Buying Committee",
    tooltip:
      "Buying committee - a group of people inside the target account who will be directly involved" +
      " in the decision-making process.",
    icon: <TwoPersonIcon color="#1C3C6C" />,
  },
  [Groups.cluster]: {
    label: "Buying Cluster",
    tooltip:
      "Buying cluster - a narrow group involved in final decision-making inside the larger buying committee.",
    icon: <TwoPersonIcon />,
  },
};

export const BuyingGroup = ({ group }: { group: Groups }) => {
  return (
    <ReuseTooltip text={mapper[group].tooltip} hideChildren={false}>
      <Stack
        flexDirection="row"
        alignItems="center"
        gap="8px"
        sx={{ cursor: "pointer" }}
      >
        {mapper[group].icon}
        <Typography variant="body1" color="#1F2932">
          {mapper[group].label}
        </Typography>
      </Stack>
    </ReuseTooltip>
  );
};
